export const COMPANY_ROUTES = {
  BASE: '/company',
  FIND_CANDIDATES: '/company/find-candidates',
  JOB_POSTS: '/company/job-posts',
  CULTURE_PROFILES: '/company/culture-profiles',
  CANDIDATE_OVERVIEW: '/company/candidate-overview',
  CAREER_PAGE: '/company/career-page',
  SETTINGS: '/company/settings',
  PLANS: '/company/plans',
  CULTURE_WIZARD: '/company/culture',
  career: (jobId: string | number, candidateId: string | number) =>
    `/company/career/${jobId}/${candidateId}`,
  jobPost: (id: string | number) => `/company/job-posts/${id}`,
  jobPostRequests: (id: string | number) => `/company/job-posts/${id}/requests`,
  jobPostFind: (id: string | number) => `/company/job-posts/${id}/find`,
  findCandidate: (id: string | number) => `/company/find-candidate/${id}`,
  matchCandidate: (id: string | number) => `/company/match-candidate/${id}`,
  matchResult: (type: string, id: string | number) =>
    `/company/match-result/${type}/${id}`
} as const;

export const jobMatchesRouteParam = (
  job: { id?: number | string; slug?: string } | null | undefined,
  routeId?: string
): boolean =>
  Boolean(
    job &&
      routeId &&
      (String(job.id) === String(routeId) ||
        (job.slug != null && String(job.slug) === String(routeId)))
  );

export const COMPANY_DEFAULT_ROUTE = COMPANY_ROUTES.FIND_CANDIDATES;

export const COMPANY_TAB_PATHS = [
  COMPANY_ROUTES.FIND_CANDIDATES,
  COMPANY_ROUTES.JOB_POSTS,
  COMPANY_ROUTES.CULTURE_PROFILES,
  COMPANY_ROUTES.CANDIDATE_OVERVIEW,
  COMPANY_ROUTES.CAREER_PAGE
] as const;

export const getCompanyReturnRoute = (items?: {
  postAJob?: boolean;
  is_culture?: boolean;
}): string => {
  if (items?.postAJob) {
    return COMPANY_ROUTES.JOB_POSTS;
  }
  if (items?.is_culture) {
    return COMPANY_ROUTES.CULTURE_PROFILES;
  }
  return COMPANY_DEFAULT_ROUTE;
};
